import { render, staticRenderFns } from "./BhRuleConfig.vue?vue&type=template&id=1b3c869e&scoped=true"
import script from "./BhRuleConfig.vue?vue&type=script&lang=js"
export * from "./BhRuleConfig.vue?vue&type=script&lang=js"
import style0 from "./BhRuleConfig.vue?vue&type=style&index=0&id=1b3c869e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3c869e",
  null
  
)

export default component.exports